import styles from "./styles.module.css";
import { ModuleProps } from "components/props/ModuleProps"
import { IconPicker } from "components/layout/icons/IconPicker";

interface ModuleErrorProps {
    module: ModuleProps;
    text: string;
}
export const ModuleError = ({
    module,
    text
}: ModuleErrorProps) => {

    return (
        <div className={`${styles.bar} ${styles.barError}`}>
            <div className={styles.barContent}>
                <div>
                    <h6>En feil oppstod</h6>
                    <p>{text}</p>
                </div>
                <div>
                    <IconPicker icon={module.icon} size={24} color="var(--white)" />
                </div>
            </div>
        </div>
    );
}
